var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpeechBubbleTeam = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "speech-bubble-team-a",
    d: "M27,8 C28.1,8 29,8.9160898 29,10.0357551 L29,22.2502857 C29,23.369951 28.1,24.2860408 27,24.2860408 L13.5042735,24.2860408 L9,28.3575511 L9,10.0357551 C9,8.9160898 9.9,8 11,8 L27,8 Z M43.8,31 C45.56,31 47,32.4657437 47,34.2572082 L47,53.8004572 C47,55.5919217 45.56,57.0576654 43.8,57.0576654 L22.2068376,57.0576654 L15,63.5720817 L15,34.2572082 C15,32.4657437 16.44,31 18.2,31 L43.8,31 Z M53,37.1718531 L53,32.2572082 C53,28.2723141 49.7851594,25 45.8,25 L38,25 L38,18.6464816 C38,17.1909167 39.17,16 40.6,16 L61.4,16 C62.83,16 64,17.1909167 64,18.6464816 L64,42.4648164 L58.1444444,37.1718531 L53,37.1718531 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#speech-bubble-team-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpeechBubbleTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/speech-bubble-team.14ed8fe667773a42abf341a86fc33dff.svg";